import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE = gql`
    query advanceTypesActive {
        advanceTypesActive {
            id
            name
            is_active
            apply_afp
            status_text
        }
    }
`
const GET_WITH_PAGINATION = gql`
    query advanceTypesWithPagination ($page: Int, $perPage: Int) {
        advanceTypesWithPagination (page: $page, first: $perPage) {
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                name
                is_active
                apply_afp
                status_text
            }
        }
    }
`
/**
 * Mutations
 */
 const CREATE = gql`
 mutation createAdvanceType ($input: AdvanceTypeInput!) {
    createAdvanceType (input: $input) {
         id
         name
         is_active
         status_text
     }
 }
`

const UPDATE = gql`
 mutation updateAdvanceType ($id: ID!, $input: AdvanceTypeInput!) {
    updateAdvanceType (id: $id, input: $input) {
         id
         name
         is_active
         status_text
     }
 }
`

const DELETE = gql`
 mutation deleteAdvanceType ($id: ID!) {
     deleteAdvanceType (id: $id) {
         id
         name
         is_active
         status_text
     }
 }
`

export {
    ALL_ACTIVE,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    DELETE
}
